'use strict';
angular.module('myResourcesQuickPreviewModule', ['myResourcesDetailModule']).controller('myResourcesQuickPreviewCtrl', [
    '$scope',
    '$state',
    'trsHttpService',
    '$timeout',
    '$stateParams',
    'globleParamsSet',
    'resCtrModalService',
    'trsspliceString',
    'storageListenerService',
    function($scope, $state, trsHttpService, $timeout, $stateParams, globleParamsSet, resCtrModalService, trsspliceString, storageListenerService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                searchShow: false,
                screenShow: false,
                curSelected: '', //选中的稿件ID
                showRightDetail: false, //是否显示右侧详情
            };
            $scope.data = {
                items: [],
                rebuildData: '',
                indexName: '',
                keyword: $stateParams.searchword === undefined ? '' : $stateParams.searchword,
                operFlags: [],
                flagTotalItems: [],
                filterTypes: [
                    { name: '全部', value: '0' },
                    { name: '标题', value: '1' },
                    { name: '媒体', value: '2' },
                    { name: '正文', value: '3' },
                ],
            };
            $scope.data.filterTypeSelected = angular.copy($scope.data.filterTypes[0]);
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.getPageSize(),
                PAGECONUT: 0,
                ITEMCOUNT: 0,
            };
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'subSearch',
                id: $stateParams.groupid,
            };
        }
        /** [initData description] 初始化数据的功能 */
        function initData() {
            listenStorage();
            //requestData();
            if (angular.isDefined($scope.$root.filterData)) {
                //判断是否有传递的数据
                var filterData = angular.copy($scope.$root.filterData);
                $scope.page = filterData.page;
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                if (!!filterData.content_keyword) {
                    //检索词
                    $scope.status.searchShow = true;
                    $scope.status.isSearch = true;
                    $scope.params.content_keyword = $scope.data.keyword = filterData.content_keyword;
                }

                $scope.data.filterTypeSelected = filterData.selectedSearch; //检索类型
                if (angular.isDefined(filterData.fromdate) && filterData.fromdate != '') {
                    //时间下拉选择
                    $scope.data.fromdate = angular.copy(filterData.fromdate);
                    $scope.data.untildate = angular.copy(filterData.untildate);
                    $scope.params.time = $scope.data.fromdate + ',' + $scope.data.untildate;
                }
                requestData();
            } else {
                requestData();
            }
            $scope.$on('$destroy', function() {
                delete $scope.$root.filterData;
            });
        }
        /** [requestData description]请求数据得操作 */
        function requestData() {
            if ($scope.status.isSearch) {
                $scope.params.search_type = $scope.data.filterTypeSelected.value;
            }
            $scope.params.pageSize = $scope.page.PAGESIZE;
            $scope.params.pageNum = $scope.page.CURRPAGE;
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                $scope.page.CURRPAGE = data.summary_info.CURRPAGE;
                $scope.page.PAGECOUNT = data.summary_info.PAGECONUT;
                $scope.data.items = data.content;
                storageListenerService.previewPageTurningStorage($scope.data.items, 'ZB_GUID', 'resourceDetail');
                $scope.data.indexName = data.summary_info.indexName;
                //initSelectedDraft(data);
                initOperFlag();
                if ($scope.data.items.length > 0) {
                    //默认显示第一篇详情
                    showDetail($scope.data.items[0]);
                }
                getFilterDataBack();
            });
        }
        /**
         * [getFilterDataBack description]获取跳转回普通视图存储信息
         * @return {[type]} [description]
         */
        function getFilterDataBack() {
            $scope.$root.filterDataBack = {
                page: $scope.page, //分页
                content_keyword: $scope.params.content_keyword, //检索词
                selectedSearch: $scope.data.filterTypeSelected, //检索类型
                fromdate: $scope.data.fromdate, //开始时间
                untildate: $scope.data.untildate, //结束时间
            };
        }
        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }
        /**
         * [initSelectedDraft description] 初始化选中稿件
         * @return {[type]} [description]
         */
        /*function initSelectedDraft(data) {
            var guid = $state.params.guid ? $state.params.guid : data.content[0].ZB_GUID;
            $scope.data.rebuildData = { guid: guid, indexName: $scope.data.indexName };
            $scope.status.curSelected = guid;
            $state.params.guid = guid;
            $state.go($state.current.name, $state.params, { reload: false });
        }*/
        /** [initOperFlag description]初始化取签见重 1*/
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
        }
        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDetail = function(item) {
            showDetail(item);
        };
        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function showDetail(item) {
            $scope.status.showRightDetail = false;
            $scope.data.rebuildData = {
                guid: item.ZB_GUID,
                indexName: $scope.data.indexName,
            };
            $timeout(function() {
                $scope.status.curSelected = item.ZB_GUID;
                $scope.status.showRightDetail = true;
            }, 0);
            $scope.$watch('data.rebuildData', function(newVal, oldVal) {
                $('.detailsRight_content_wrap').scrollTop(0);
            });
        }
        /** [showDetail description：展示预览详情数据] */
        /*$scope.showDetail = function(item) {
            $state.params.guid = item.ZB_GUID;
            $state.go($state.current.name, $state.params, { reload: false });
            $scope.data.rebuildData = { guid: item.ZB_GUID, indexName: $scope.data.indexName };
            $scope.status.curSelected = item.ZB_GUID;
        };*/
        /** [fullTextSearch description]关键字查询相关稿件信息 */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isSearch = true;
                $scope.params.content_keyword = $scope.data.keyword;
                delete $state.params.guid; //检索时清除稿件id定位功能
                requestData();
            }
        };
        /** [plainView description]回到列表页 */
        $scope.plainView = function() {
            if (!$stateParams.groupid) {
                $state.go('front.networksource.myresources.search', $stateParams);
            } else {
                $state.go('front.networksource.myresources.subscriptionfolderson', $stateParams);
            }
        };
        /** [requestData description] 分页跳转执行的数据请求函数 */
        $scope.pageChanged = function() {
            delete $state.params.guid; //分页时清除稿件id定位功能
            requestData();
            $('.myResourcesQuickPreview .previewLeft_content').animate({
                scrollTop: $('.myResourcesQuickPreview .previewLeft_content').offset().top - 250,
            });
        };
        /** [queryDateNews description] 根据时间来进行信息的获取 */
        $scope.queryDateNews = function() {
            if ($scope.data.fromdate != '') {
                var time = [$scope.data.fromdate, $scope.data.untildate].join(',');
                $scope.params.time = time;
            } else {
                delete $scope.params.time;
            }
            delete $state.params.guid; //检索时清除稿件id定位功能
            requestData();
        };
        /**
         * [showSearch description] 显示隐藏搜索框
         * @return {[type]} [description]
         */
        $scope.showSearch = function() {
            $scope.status.searchShow = !$scope.status.searchShow;
            $scope.status.screenShow = false;
        };
        /** [viewBigDataInfo description]取签侧重的弹框展示 */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick, $event) {
            var operFlags = queryItemBYGUID(ChnlDocId);
            operFlags = operFlags.OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            event.stopPropagation();
        };
        /**
         * [showScreen description] 显示隐藏搜索框
         * @return {[type]} [description]
         */
        $scope.showScreen = function() {
            $scope.status.screenShow = !$scope.status.screenShow;
            $scope.status.searchShow = false;
        };
        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex, flag) {
            var temp = queryItemBYGUID(guid, flag);
            if (!!temp) {
                return queryItemBYGUID(guid, flag).OPERFLAG.substr(flagIndex, 1) == '1' ? true : false;
            } else {
                return false;
            }
        };
        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(id, flag) {
            for (var i in $scope.data.operFlags) {
                if (id == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }
    },
]);
